import React from 'react';

import { trackEvent } from '@xingternal/hops-tracking';

export const useAlertLightbox = ({ initialOrigin }) => {
  const [isAlertLightboxOpen, setIsAlertLightboxOpen] = React.useState(false);
  const [propActionOrigin, setPropActionOrigin] = React.useState(initialOrigin);

  const trackOpenLightbox = (actionOrigin?: string) => {
    trackEvent('PropTrackAction', {
      PropTrackAction: 'jobs_search_alert_create_open',
      PropActionOrigin: actionOrigin || propActionOrigin,
    });
  };

  const toggleAlertLightbox = ({ actionOrigin }: { actionOrigin?: string } = {}) => {
    if (actionOrigin) {
      setPropActionOrigin(actionOrigin);
    }

    const nextOpenState = !isAlertLightboxOpen;
    if (nextOpenState) trackOpenLightbox(actionOrigin);

    setIsAlertLightboxOpen(nextOpenState);
  };

  return { isAlertLightboxOpen, toggleAlertLightbox, propActionOrigin };
};
